import { apiClient } from '@/shared/api/client'

/** Fuseau horaire SYSTÈME (unique). Lecture libre, écriture réservée au owner. */
export const SystemAPI = {
  getTimezone(): Promise<string> {
    return apiClient
      .get('/api/pexitalk/accounts/system-settings/')
      .then((r) => r.data.timezone as string)
  },
  setTimezone(timezone: string): Promise<string> {
    return apiClient
      .put('/api/pexitalk/accounts/system-settings/', { timezone })
      .then((r) => r.data.timezone as string)
  },
}

export interface MicSettings {
  denoise_level: number  // 0 (clarté max) → 3 (anti-bruit max)
  gate_db: number        // seuil du filtre de proximité (dBFS)
}

/** Réglages micro du tenant (softphone). Lecture libre (poussés à tous les
 *  agents), écriture réservée au owner. */
export const MicAPI = {
  get(): Promise<MicSettings> {
    return apiClient
      .get('/api/pexitalk/accounts/mic-settings/')
      .then((r) => r.data as MicSettings)
  },
  set(settings: MicSettings): Promise<MicSettings> {
    return apiClient
      .put('/api/pexitalk/accounts/mic-settings/', settings)
      .then((r) => r.data as MicSettings)
  },
}
